"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const FormElementError = ({
  className,
  children
}) => {
  const classes = (0, _classnames.default)('FormElementError', className);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: classes
  }, children);
};
var _default = exports.default = FormElementError;